/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ConnectAccountGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export type ConnectAccountRequest = {
  accountID: string;
  shareScopes: components.ShareScopes;
};

export type ConnectAccountResponse = {
  headers: { [k: string]: Array<string> };
};

/** @internal */
export const ConnectAccountGlobals$inboundSchema: z.ZodType<
  ConnectAccountGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type ConnectAccountGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const ConnectAccountGlobals$outboundSchema: z.ZodType<
  ConnectAccountGlobals$Outbound,
  z.ZodTypeDef,
  ConnectAccountGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function connectAccountGlobalsToJSON(
  connectAccountGlobals: ConnectAccountGlobals,
): string {
  return JSON.stringify(
    ConnectAccountGlobals$outboundSchema.parse(connectAccountGlobals),
  );
}
export function connectAccountGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<ConnectAccountGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConnectAccountGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConnectAccountGlobals' from JSON`,
  );
}

/** @internal */
export const ConnectAccountRequest$inboundSchema: z.ZodType<
  ConnectAccountRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  accountID: z.string(),
  ShareScopes: components.ShareScopes$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "ShareScopes": "shareScopes",
  });
});
/** @internal */
export type ConnectAccountRequest$Outbound = {
  accountID: string;
  ShareScopes: components.ShareScopes$Outbound;
};

/** @internal */
export const ConnectAccountRequest$outboundSchema: z.ZodType<
  ConnectAccountRequest$Outbound,
  z.ZodTypeDef,
  ConnectAccountRequest
> = z.object({
  accountID: z.string(),
  shareScopes: components.ShareScopes$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    shareScopes: "ShareScopes",
  });
});

export function connectAccountRequestToJSON(
  connectAccountRequest: ConnectAccountRequest,
): string {
  return JSON.stringify(
    ConnectAccountRequest$outboundSchema.parse(connectAccountRequest),
  );
}
export function connectAccountRequestFromJSON(
  jsonString: string,
): SafeParseResult<ConnectAccountRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConnectAccountRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConnectAccountRequest' from JSON`,
  );
}

/** @internal */
export const ConnectAccountResponse$inboundSchema: z.ZodType<
  ConnectAccountResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
  });
});
/** @internal */
export type ConnectAccountResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
};

/** @internal */
export const ConnectAccountResponse$outboundSchema: z.ZodType<
  ConnectAccountResponse$Outbound,
  z.ZodTypeDef,
  ConnectAccountResponse
> = z.object({
  headers: z.record(z.array(z.string())),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
  });
});

export function connectAccountResponseToJSON(
  connectAccountResponse: ConnectAccountResponse,
): string {
  return JSON.stringify(
    ConnectAccountResponse$outboundSchema.parse(connectAccountResponse),
  );
}
export function connectAccountResponseFromJSON(
  jsonString: string,
): SafeParseResult<ConnectAccountResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ConnectAccountResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ConnectAccountResponse' from JSON`,
  );
}
